module.exports = __webpack_public_path__ + "static/media/pause-button.458cc6b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/pause-button.svg
// module id = 188
// module chunks = 0